// Inspired by WuTang
import UnitsFormatter from './UnitsFormatter';

export default function format(value, full) {
  return `£${UnitsFormatter(value, full)}`;
}
